import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

export default function StepSessionWithTopic({ assignTopic, position, onTopicRemove }) {
  const className = assignTopic.attributes.special_type === 'employee_choice' ? 'employee-choice' : '';

  return (
    <div className="selected-topic icon-with-text">
      <div className="counting-icon" />

      <div className="flex-fill">
        <div className={`topic-to-select icon-with-text ms-2 ${className}`}>
          <i
            style={{
              WebkitMaskImage: `url(${assignTopic.attributes.icon})`,
              maskImage: `url(${assignTopic.attributes.icon})`,
            }}
          />

          <div className="text-content">{assignTopic.attributes.title}</div>

          <Button variant="link" onClick={() => onTopicRemove(position)} className="ms-auto icon-with-text">
            <i className="cancel" style={{ minWidth: '25px' }} />
          </Button>
        </div>
      </div>
    </div>
  );
}

StepSessionWithTopic.propTypes = {
  assignTopic: PropTypes.object.isRequired,
  position: PropTypes.number.isRequired,
  onTopicRemove: PropTypes.func,
};

StepSessionWithTopic.defaultProps = {
  onTopicRemove: () => {},
};
